module.exports = __webpack_public_path__ + "img/ko.47c21ce1.webp";